import {
  GET_ONE_INVOICE_GL_PERIOD_REQUEST,
  GET_ONE_INVOICE_GL_PERIOD_SUCCESS,
  GET_ONE_INVOICE_GL_PERIOD_ERROR,
} from "../actions/types";
export default function (state = [], action) {
  const { type, payload } = action;
  switch (type) {
    case GET_ONE_INVOICE_GL_PERIOD_REQUEST:
      return {
        loading: true,
      };
    case GET_ONE_INVOICE_GL_PERIOD_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_ONE_INVOICE_GL_PERIOD_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
